import React from 'react';
import Pusher from 'pusher-js';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { getFormValues, isDirty } from 'redux-form';
import { push } from 'react-router-redux';
import moment from 'moment';
import * as action from 'actions';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import ConfirmActionModal from 'components/ConfirmActionModal';
import * as actInvTrf from 'actions/inventory/transfer';
import { askConfirmAction } from 'actions/confirm-action';
import * as actNotif from 'actions/notifications';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { PUSHER_APP_KEY } from 'api/constants';

import * as clevertapInventoryTransfer from 'clevertap/inventory/transfer';

import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS,
} from 'actions/inventory/constants';
import TransferDetail from './TransferDetail';
import List from './List';
import ActionBar from './ActionBar';

class Transfer extends React.Component {
  componentDidMount() {
    const { dispatch, id } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });

    this.channel = pusher.subscribe(`moka-${id}-inventory`);

    dispatch(actInvTrf.pageRequest());
    browserHistory.listenBefore(location => {
      const { isDirtyTransfer, nextAction } = this.props;
      if (isDirtyTransfer && !nextAction) {
        dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  componentDidUpdate() {
    const { dispatch, idAsyncJob } = this.props;

    this.channel.bind('library/transfer/export', data => {
      if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob === data.resource_id &&
        data.type === 'export-done'
      ) {
        dispatch(actInvTrf.doneExportTransfer());
        dispatch(action.showLoadingSpinner(false));
        window.location.href = data.url_path;
      } else if (
        idAsyncJob &&
        data.resource_id &&
        idAsyncJob === data.resource_id &&
        !data.success
      ) {
        dispatch(actInvTrf.errorExportTransfer(data));
      }
    });
  }

  render() {
    const {
      transfers,
      currentPage,
      totalPage,
      showLoadingSpinnerPage,
      transferDetail,
      openRightColumn,
      outlets,
      selectedOutlets,
      showAddItemsModal,
      showConfirmSubmitModal,
      addItems,
      itemOptionIsLoading,
      transferItem,
      searchForm,
      isItemAlreadyAdded,
      isDirtyTransfer,
      exportButtonStatus,
      confirmCreateButtonStatus,
      addTransferItems,
      isIngredientActive,
    } = this.props;

    return (
      <PageWrapper>
        <ActionBar
          outlets={outlets}
          isDirtyForm={isDirtyTransfer}
          exportButtonStatus={exportButtonStatus}
          actionBarOnClickExport={this._actionBarOnClickExport}
          actionBarOnClickCreateTransfer={this._actionBarOnClickCreateTransfer}
          actionBarOnChangeOutletIds={this._actionBarOnChangeOutletIds}
          actionBarOnChangeDate={this._actionBarOnChangeDate}
          actionBarOnChangeNamespace={this._actionBarOnChangeNamespace}
          isIngredientActive={isIngredientActive}
        />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={transfers.length === 0}
              title="No Data To Display"
              description=""
              linkLabel="Transfer Stock Between Outlets"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000421106-Cara-Transfer-Barang-atau-Bahan-Baku"
            />
            <List
              searchForm={searchForm}
              transfers={transfers}
              transferDetail={transferDetail}
              currentPage={currentPage}
              totalPage={totalPage}
              listOnClickRow={this._listOnClickRow}
              listOnReachBottom={this._listOnReachBottom}
              showLoadingSpinner={showLoadingSpinnerPage}
            />
          </LeftColumnWrapper>
          <RightColumnWrapper
            openRightColumn={openRightColumn}
            menuName="transfer"
          >
            <TransferDetail
              searchForm={searchForm}
              transferDetail={transferDetail}
              onClickDone={this._onDetailTransferClickDone}
              outlets={outlets}
              selectedOutlets={selectedOutlets}
              showAddItemsModal={showAddItemsModal}
              addItems={addItems}
              onClickAddItem={this._onClickAddItem}
              onModalClickCancel={this._onModalClickCancel}
              onFromOutletChange={this._onFromOutletChange}
              itemOptionIsLoading={itemOptionIsLoading}
              onModalSelectChange={this._onModalSelectChange}
              onModalAddItems={this._onModalAddItems}
              setShowConfirmSubmitModal={this._setShowConfirmSubmitModal}
              onSubmitCreateTransferForm={this._onSubmitCreateTransferForm}
              showConfirmSubmitModal={showConfirmSubmitModal}
              onConfirmCreateTransfer={this._onConfirmCreateTransfer}
              transferItemForm={transferItem}
              addTransferItemsForm={addTransferItems}
              isItemAlreadyAdded={isItemAlreadyAdded}
              onModalSelectInputChange={this._onModalSelectInputChange}
              confirmCreateButtonStatus={confirmCreateButtonStatus}
              onModalSearchReachBottom={this._onModalSearchReachBottom}
              onModalGetFromInit={this._onModalGetFromInit}
              clickLinkIngredient={this._onClickLinkIngredient}
            />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
      </PageWrapper>
    );
  }

  // LIST COMPONENT START
  _listOnClickRow = transfer => {
    const { dispatch, isDirtyTransfer } = this.props;
    if (isDirtyTransfer) {
      dispatch(askConfirmAction(actInvTrf.onClickRow(transfer)));
    } else {
      dispatch(actInvTrf.onClickRow(transfer));
    }
  };

  _listOnReachBottom = () => {
    const {
      dispatch,
      currentPage,
      transfers,
      searchForm: { date, namespace },
    } = this.props;
    const { startDate, endDate } = date;
    dispatch(
      actInvTrf.transfersRequest(
        {
          page: currentPage + 1,
          start: startDate.format('YYYY-MM-DDThh:mm:SS.SSSZ'),
          end: endDate.format('YYYY-MM-DDThh:mm:SS.SSSZ'),
        },
        transfers,
        namespace
      )
    );
  };
  // LIST COMPONENT END

  // ACTIONBAR COMPONENT START
  _actionBarOnClickExport = () => {
    const {
      dispatch,
      searchForm: {
        outletIds,
        date: { startDate, endDate },
        namespace,
      },
    } = this.props;

    const dateLabel = startDate.isSame(endDate, 'days')
      ? moment(startDate).format('DD-MM-YYYY')
      : [
          moment(startDate).format('DD-MM-YYYY'),
          moment(endDate).format('DD-MM-YYYY'),
        ].join(' - ');

    let title = '';
    if (namespace === NAMESPACE_ITEMS) {
      title = 'Inventory Transfer - ';
    } else if (namespace === NAMESPACE_INGREDIENTS) {
      title = 'Ingredient Inventory Transfer - ';
    }

    const filename = title + dateLabel;

    dispatch(
      actInvTrf.exportTransfer(
        {
          start_date: startDate.format('DD/MM/YYYY'),
          end_date: endDate.format('DD/MM/YYYY'),
        },
        filename,
        outletIds[0],
        namespace
      )
    );

    clevertapInventoryTransfer.inventoryTransferExport({
      outletIds,
      startDate,
      endDate,
      namespace,
    });
  };

  _actionBarOnClickCreateTransfer = () => {
    const { dispatch, searchForm, isDirtyTransfer, outlets } = this.props;
    if (outlets.length > 1) {
      if (searchForm) {
        if (isDirtyTransfer) {
          dispatch(
            askConfirmAction(
              actInvTrf.onClickCreateTransfer(searchForm.outletIds[0])
            )
          );
        } else {
          dispatch(actInvTrf.onClickCreateTransfer(searchForm.outletIds[0]));
        }
      }
    } else {
      dispatch(
        actNotif.error(
          "Transfer is unavailable because you don't have more than 1 outlet"
        )
      );
    }
  };

  _actionBarOnChangeOutletIds = outletIds => {
    const {
      searchForm: {
        date: { startDate, endDate },
        namespace,
      },
      dispatch,
      isDirtyTransfer,
    } = this.props;
    if (isDirtyTransfer) {
      dispatch(
        askConfirmAction(
          actInvTrf.onChangeOutletIds(outletIds, startDate, endDate, namespace)
        )
      );
    } else {
      dispatch(
        actInvTrf.onChangeOutletIds(outletIds, startDate, endDate, namespace)
      );
    }
  };

  _actionBarOnChangeDate = values => {
    const { startDate, endDate } = values;
    const {
      dispatch,
      isDirtyTransfer,
      searchForm: { namespace },
    } = this.props;
    if (isDirtyTransfer) {
      dispatch(
        askConfirmAction(actInvTrf.onChangeDate(startDate, endDate, namespace))
      );
    } else {
      dispatch(actInvTrf.onChangeDate(startDate, endDate, namespace));
    }
  };

  _actionBarOnChangeNamespace = namespace => {
    const { dispatch, isDirtyTransfer } = this.props;
    if (isDirtyTransfer) {
      dispatch(askConfirmAction(actInvTrf.onNamespaceChange(namespace)));
    } else {
      dispatch(actInvTrf.onNamespaceChange(namespace));
    }
  };
  // ACTIONBAR COMPONENT END

  // when close right column
  _onDetailTransferClickDone = () => {
    const { dispatch } = this.props;
    dispatch(actInvTrf.closeRightColumn());
    dispatch(actInvTrf.setTransferDetail(null));
  };

  // when clicked add items in create transfer form
  _onClickAddItem = () => {
    const {
      transferItem,
      searchForm: { namespace },
      dispatch,
    } = this.props;
    dispatch(actInvTrf.setSearchItemsInit([]));
    if (namespace === 'items') {
      dispatch(
        actInvTrf.getItems(
          transferItem.fromOutlet,
          '',
          0,
          namespace,
          true,
          false,
          [],
          null,
          []
        )
      );
    } else {
      dispatch(
        actInvTrf.getItems(
          transferItem.fromOutlet,
          '',
          1,
          namespace,
          true,
          false,
          [],
          null,
          []
        )
      );
    }
    dispatch(actInvTrf.onClickAddItem());
  };

  // when clicked cancel in addItems modal
  _onModalClickCancel = () => {
    const { dispatch } = this.props;
    dispatch(actInvTrf.onModalClickCancel());
    dispatch(actInvTrf.resetAddItems());
    dispatch(actInvTrf.setIsItemAlreadyAdded(false));
  };

  // when fromOutlet filed value in create transfer form change
  _onFromOutletChange = () => {
    this.props.dispatch(actInvTrf.resetAddItems());
    this.props.dispatch(actInvTrf.resetTransfersForm());
  };

  // when select in add item modal change
  _onModalSelectChange = (selectedItemId, items, transfers) => {
    const { searchForm, dispatch } = this.props;
    dispatch(
      actInvTrf.onModalSelectChange(
        selectedItemId,
        items,
        transfers,
        searchForm.namespace
      )
    );
  };

  _onModalSelectInputChange = keyword => {
    const {
      transferItem: { fromOutlet },
      searchForm,
      dispatch,
    } = this.props;
    const page = searchForm.namespace === 'items' ? 0 : 1;

    dispatch(actInvTrf.setIsItemAlreadyAdded(false));
    dispatch(
      actInvTrf.getItems(
        fromOutlet,
        keyword,
        page,
        searchForm.namespace,
        false,
        false,
        [],
        null,
        []
      )
    );
  };

  _onModalSearchReachBottom = keyword => {
    const {
      transferItem: { fromOutlet },
      searchForm,
      addItems,
      dispatch,
    } = this.props;
    if (
      addItems.items.length > 0 &&
      addItems.currentPage < addItems.totalPage
    ) {
      dispatch(
        actInvTrf.getItems(
          fromOutlet,
          keyword,
          addItems.currentPage + 1,
          searchForm.namespace,
          false,
          false,
          addItems.items,
          addItems.totalPage,
          []
        )
      );
    }
  };

  _onModalGetFromInit = () => {
    const { searchItemsInit, dispatch } = this.props;
    dispatch(actInvTrf.setAddItems(searchItemsInit));
  };

  // when submit add item modal
  _onModalAddItems = items => {
    // const {dispatch, transferItem} = this.props
    // dispatch(actInvTrf.onModalAddItems(items, transferItem.transfers))
    const { dispatch } = this.props;
    dispatch(actInvTrf.onModalAddItems(items));
  };

  // when submit craete transfer form
  _onSubmitCreateTransferForm = values => {
    this.props.dispatch(actInvTrf.onSubmitCreateTransfer(values));
  };

  // to show/hide create transfer confirmAction modal
  _setShowConfirmSubmitModal = isShowConfirmSubmitModal => {
    this.props.dispatch(
      actInvTrf.setShowConfirmSubmitModal(isShowConfirmSubmitModal)
    );
  };

  _onConfirmCreateTransfer = () => {
    const {
      transferItem,
      dispatch,
      searchForm: { date, namespace },
    } = this.props;
    dispatch(actInvTrf.onConfirmCreateTransfer(transferItem, date, namespace));
  };

  _onClickLinkIngredient = () => {
    this.props.dispatch(
      askConfirmAction(actInvTrf.onNamespaceChange(NAMESPACE_INGREDIENTS))
    );
  };
}

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const { id } = state.moka.user.business;
  const {
    transfers,
    transferDetail,
    currentPage,
    totalPage,
    openRightColumn,
    outlets,
    selectedOutlets,
    showAddItemsModal,
    showConfirmSubmitModal,
    addItems,
    itemOptionIsLoading,
    isItemAlreadyAdded,
    exportButtonStatus,
    confirmCreateButtonStatus,
    searchItemsInit,
    searchItems,
    idAsyncJob,
  } = state.inventory.transfer;

  const {
    subscriptionStatus: { is_active },
  } = state.inventory.ingredientSubscription;

  return {
    showLoadingSpinnerPage,
    transfers,
    transferDetail,
    currentPage,
    totalPage,
    openRightColumn,
    outlets,
    selectedOutlets,
    showAddItemsModal,
    showConfirmSubmitModal,
    addItems,
    itemOptionIsLoading,
    isItemAlreadyAdded,
    exportButtonStatus,
    confirmCreateButtonStatus,
    searchItemsInit,
    searchItems,
    searchForm: getFormValues('search')(state),
    transferItem: getFormValues('transferItem')(state),
    addTransferItems: getFormValues('addTransferItems')(state),
    isDirtyTransfer: isDirty('transferItem')(state),
    nextAction: state.confirmAction.nextAction,
    isIngredientActive: is_active,
    id,
    idAsyncJob,
  };
}

export default connect(mapStateToProps)(Transfer);
